module.exports = __webpack_public_path__ + "img/udig.91afa13d.png";